import React from 'react';
import { Table } from 'antd';

const TotalRowAllReport = ({ filteredColumns, totalColumns, allDataTotals, formatNumber }) => {
    return (
        <Table.Summary.Row className="total-all-summary-row">
            {filteredColumns.map((column, index) => {
                // Xác định vị trí các cột mốc
                const pricingModelsIndex = filteredColumns.findIndex(col => col.dataIndex === 'Pricingmodels');
                const unitPriceIndex = filteredColumns.findIndex(col => col.dataIndex === 'UnitPrice');

                // Xác định class dựa trên vị trí cột
                let cellClassName = 'summary-cell';
                
                // Hiển thị "TotalAll" cho các cột từ đầu đến Pricing Models
                if (index <= pricingModelsIndex) {
                    cellClassName += ' summary-cell-green';
                    // Chỉ hiển thị text "TotalAll" ở cột đầu tiên
                    if (index === 0) {
                        return (
                            <Table.Summary.Cell 
                                key="total-all-label" 
                                index={0}
                                className={cellClassName}
                                colSpan={pricingModelsIndex + 1} // Gộp các cột từ đầu đến Pricing Models
                            >
                                <strong>Total All</strong>
                            </Table.Summary.Cell>
                        );
                    }
                    // Bỏ qua các cột đã được gộp
                    if (index < pricingModelsIndex + 1) {
                        return null;
                    }
                } else if (index === unitPriceIndex) {
                    cellClassName += ' summary-cell-normal';
                } else {
                    cellClassName += ' summary-cell-purple';
                }

                if (totalColumns.includes(column.dataIndex)) {
                    return (
                        <Table.Summary.Cell
                            key={`total-all-${column.dataIndex}`}
                            index={column.dataIndex}
                            align="right"
                            className={cellClassName}
                        >
                            {formatNumber(allDataTotals[column.dataIndex])}
                        </Table.Summary.Cell>
                    );
                }
                
                return (
                    <Table.Summary.Cell 
                        key={`total-all-${column.dataIndex}`} 
                        index={column.dataIndex}
                        className={cellClassName}
                    />
                );
            })}
        </Table.Summary.Row>
    );
};

export default TotalRowAllReport;